import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69c2e36a7d947e0014cdb03b/electricianschargeact/src/app/apply/page.tsx");
